import api from "./Api";

class PagarPagamentoService {
  GetPagarPagamento(payload) {
    return api.get("/v1/pagarPagamento/" + payload).then((response) => {
      return response.data;
    });
  }

  PostPagarPagamento(payload) {
    return api.post("/v1/pagarPagamento/", payload).then((response) => {
      return response.data;
    });
  }

  PutPagarPagamento(payload) {
    return api.put("/v1/pagarPagamento/", payload).then((response) => {
      return response.data;
    });
  }

  DeletePagarPagamento(payload) {
    return api.delete("/v1/pagarPagamento/" + payload).then((response) => {
      return response.data;
    });
  }

  GetPagarPagamentoOData(payload) {
    return api.get("/OData/PagarPagamento" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new PagarPagamentoService();
